import { inject, Injectable } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import { BestellvorschlagBewe } from '../data/bestellvorschlag-bewe';
import { SOFTLINE_API_MDE_BESTELLVORSCHLAG_CHECK } from '../bestellvorschlag.api';
import { BestellvorschlagArtikelCheck } from '../data/bestellvorschlag-artikel-check';

@Injectable()
export class CheckOrderService {
  readonly #dataAccess = inject(ApiDataAccess);

  async check(
    payload: Partial<BestellvorschlagBewe>
  ): Promise<BestellvorschlagArtikelCheck | null> {
    const result = await this.#dataAccess.create<
      Partial<BestellvorschlagBewe>,
      { result: BestellvorschlagArtikelCheck }
    >(
      {
        path: SOFTLINE_API_MDE_BESTELLVORSCHLAG_CHECK,
      },
      payload
    );

    if (result && !!result?.result) {
      return result?.result;
    }

    return null;
  }
}
